import { TableBodyCell } from '@pocketlaw/tetris';
import { TypeAvatarWithLabel } from 'shared/domains/common-ui';
export function NameCell(props) {
    const { to, title, type, headers } = props;
    return (<TableBodyCell headers={headers}>
      <TypeAvatarWithLabel size="sm" link={to} truncate title={title} type={type}/>
    </TableBodyCell>);
}
